<template>
    <div class="modal fade" id="trade-pin-detail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div v-if="Object.keys(pin).length" class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Trade for: {{ pin.title }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div v-if="tradeStep < 4" class="trade-step">
                    <div class="modal-body">

                        <PinDetails
                            :id="pin.pin_id"
                            :name="pin.name"
                            :thumb="pin.image_pinail"
                            :url="pin.url"
                            :series="pin.series"
                            :series-url="pin.series_url"
                            :edition="pin.edition"
                            :edition-code="pin.edition_code"
                            :edition-size="pin.edition_size"
                            :rarity="pin.rarity"
                            :is-grail="!!pin.is_grail"
                            :is-iso="!!pin.is_iso"
                            :is-owned="!!pin.alreadyOwn"
                            :released="pin.released_at"
                            :price="pin.original_price"
                            :tags="pin.tags"
                            :profile-url="pin.profile_url"
                            :condition="pin.condition"
                            :ledger="pin.ledger"
                            :summary="pin.lister_details ? pin.lister_details.summary : summary"
                            :table="pin.lister_details"
                            :ratings="pin.lister_ratings"
                        ></PinDetails>

                        <div v-if="pin.traded" class="alert alert-danger" role="alert">
                            <h4 class="alert-heading">This pin has been traded.</h4>
                            This pin has already been traded and is no longer available to receive trade offers.
                        </div>
                        <template v-else>

                            <div v-if="tradeStep === 1">
                                <!-- <div v-if="!pin.pendingOffer" class="alert alert-iso" role="alert">
                                    <h4 class="alert-heading">Want to trade for this pin?</h4>
                                    <span v-if="pin.isScrapper">
                                        This is a non-authentic SCRAPPER pin. Only trade pins that are comparable in value.
                                    </span>
                                    <span v-else>
                                        Remember Pin & Pop's Trade Protection will verify the authenticity and condition of this pin.
                                    </span>
                                </div> -->
                                <div v-if="pin.pendingOffer" class="alert alert-danger" role="alert">
                                    <h4 class="alert-heading">Pending Trade</h4>
                                    You have a pending trade offer on this pin. Good Luck!
                                </div>
                                <!-- <div v-else>
                                    <i class="fa-light fa-arrow-up-right-from-square"></i>
                                </div> -->
                            </div>
                            <div v-else-if="tradeStep === 2">
                                <div v-if="traders.length && (tokens || !tradeArcade)">
                                    <!-- <div class="alert alert-trader" role="alert">
                                        <h3 class="alert-heading fs-4">Select all the pins you're willing to trade.</h3>
                                        <p>You can select multiple pins but the trader will only be allowed to choose a single pin.</p>
                                    </div> -->
                                    <div class="p-2 mb-2 border rounded">
                                        <div><a class="d-block text-muted" data-bs-toggle="collapse" href="#trade-info">PIN & POP Trade Information <i class="fa-solid fa-caret-right"></i></a></div>
                                        <div class="collapse" id="trade-info">
                                            Although the trader con only trade for a single pin, select all the pins you're willing to offer to increase your chance of winning the trade.
                                            <div v-if="tradeArcade" class="text-muted mt-2">
                                                Successful trades cost 1 Trade Token
                                            </div>
                                        </div>
                                    </div>

                                    <TradersBoard
                                        :listed="pin.id"
                                        :rarity="pin.rarity"
                                        :user="pin.user_id"
                                        :traders="traders"
                                        :matches="listerMatches"
                                        @toggle="toggleTraderPin"
                                    ></TradersBoard>

                                </div>
                                <template v-if="tradeArcade && !tokens">
                                <div class="alert alert-warning">
                                    <h3>You need Trade Tokens:</h3>
                                    You need tokens to make trade offers on the Trade Arcade table. You can purchase tokens instantly and only spend them for successful trades.<br><strong>1.</strong> Click the "Buy Tokens" button below. <strong>2.</strong> Select the amount of tokens you want to purchase. <strong>3.</strong> Complete the purchase and return to Trade Arcade with your tokens.
                                    <p class="mt-2"><a href="/store/buy-tokens" class="btn btn-success btn-lg text-light">Buy Tokens</a></p>
                                </div>
                                </template>

                                <div v-if="uban">
                                    <div class="alert alert-danger">
                                        <h3>Account Conflict</h3>
                                        There's an issue with your account standing that impacts your trading status. Please contact <a href="mailto:support@pinandpop.com">support@pinandpop.com</a> for assistance.
                                    </div>
                                </div>
                                <div v-else-if="traders.length === 0">
                                    <div class="alert alert-warning">
                                        <h3>You need Traders:</h3>
                                        It is easy to add traders into your account...<br><strong>1.</strong> Search for a pin you own and have available for trade. <strong>2.</strong> Click the arrow next to the "OWN" button. <strong>3.</strong> When the drop down opens, click on "Trader". <strong>That's it!</strong>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="tradeStep === 3">
                                <!-- <TradersOfferConfirm :traders="traders.filter(trader => trader.selected)"></TradersOfferConfirm> -->
                                <TradersOfferConfirm :traders="[...new Map(traders.filter(trader => trader.selected).map((item) => [item['pin_id'], item])).values()]"></TradersOfferConfirm>

                                <div v-if="pin.traded" class="mt-4 alert alert-danger" role="alert">
                                    <h4 class="alert-heading">This pin has been traded.</h4>
                                    This pin has already been traded and is no longer available to receive trade offers.
                                </div>
                                <div v-else-if="tradersNA" class="mt-4 alert alert-danger" role="alert">
                                    <h4 class="alert-heading">Trade offers have been traded.</h4>
                                    Go Back and offer different pins for this trade.
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <template v-if="tradeStep === 1">
                            <button type="button" class="btn btn-link text-secondary me-4" data-bs-dismiss="modal">Close</button>
                            <template v-if="tradeArcade && !active">
                            
                            </template>
                            <template v-else-if="!traderGuest || (tradeArcade && active)">
                                <button v-if="pin.traded" class="btn btn-lg btn-danger" title="This pin has already been traded.">Pin Traded</button>
                                <button v-else-if="!pin.pendingOffer" @click="goStep(2)" type="button" class="btn btn-lg btn-trader" id="init-trade"><i class="fa-regular fa-right-left"></i> Offer Trade</button>
                                <button v-else-if="!traders" type="button" class="btn btn-lg btn-trader"><i class="fa-solid fa-circle-notch fa-spin"></i> Loading</button>
                            </template>
                            <strong v-else-if="!usub">Requires Subscription</strong>
                            <a v-else href="/register" class="btn btn-lg btn-trader">Join FREE to Trade</a>
                        </template>
                        <template v-else-if="tradeStep === 2">
                            <button type="button" class="btn btn-link text-secondary me-4" data-bs-dismiss="modal">Close</button>
                            <button v-if="pin.traded" class="btn btn-lg btn-danger" title="This pin has already been traded.">Pin Traded</button>
                            <button v-else @click="goStep(3)" type="button" :disabled="!selectedTraders" class="btn btn-lg btn-warning">Review Trade</button>
                        </template>
                        <template v-else-if="tradeStep === 3">
                            <button @click="goStep(2)" type="button" class="btn btn-link text-dark me-auto" data-bs-toggle="step-back">&lt; BACK</button>
                            <button v-if="pin.traded || listingTraded" class="btn btn-lg btn-danger" title="This pin has already been traded.">Pin Traded</button>
                            <button v-else-if="tradersNA" class="btn btn-lg btn-danger" title="Your trade offers have already been traded.">Offers Traded</button>
                            <button v-else @click="submitTrade" type="button" class="btn btn-lg btn-success"><i class="fa-regular fa-right-left"></i> Submit Trade Request</button>
                        </template>
                    </div>
                </div>
                <div v-else class="trade-step" id="trade-step-4">
                    <div class="modal-body text-center">
                        <h6 class="display-3">Pintastic!</h6>
                        <p>
                            Hooray, you've successfully requested a pin trade.<br>
                            We will notify you by email if your trade offer is accepted or not.<br><br>
                            <b>Good Luck!</b>
                        </p>
                        <button type="button" class="btn btn-lg btn-xl btn-outline-trader m-4" data-bs-dismiss="modal">Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PinDetails from "./PinDetails.vue";
import TradersBoard from "./TradersBoard.vue";
import TradersOfferConfirm from "./TradersOfferConfirm.vue";
import Confetti from "canvas-confetti";
// import {gsap} from "gsap";

export default {
    name: 'BaseModal',
    components: {
        PinDetails,
        TradersBoard,
        TradersOfferConfirm
    },
    props: {
        listings: {
            type: Array,
            required: false
        },
        boardId: {
            type: [Number, Boolean],
            required: false
        },
        tradeArcade: {
            type: Boolean,
            required: false,
            default: false
        },
        active: {
            type: Boolean,
            required: false
        },
        summary: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            tradeStep: 1,
            pin: {},
            traders: [],
            tradersLoaded: null,
            listerMatches: {},
            traderGuest: true,
            usub: false,
            uban: false,
            tokens: 0,
            tradersNA: false,
            listingTraded: false,
            processingSubmit: false
        }
    },
    computed: {
        selectedTraders() {
            return this.traders.filter(trader => trader.selected).length > 0;
        }
    },
    methods: {
        getListing(id) {
            return axios.get('/pin-trading/listings/' + id).then(response => {
                return response.data;
            }).catch(error => {
                this.handleError(error);
            });
        },

        getTraders() {
            // let params = (this.boardId !== false ? { board: this.boardId } : { listing: this.pin.id });
            let params = {};
            if (this.boardId === 0) {
                params.listings = this.listings.map(listing => listing.id).join(',');
            } else if (this.boardId !== false) {
               params.board = this.boardId;
            }
            axios.get('/my/traders', { params: params }).then((response) => {
                this.traders = response.data.traders;
                this.listerMatches.isos = response.data.isos;
                this.listerMatches.grails = response.data.grails;
                this.listerMatches.tags = response.data.tags;
                this.listerMatches.owns = response.data.owns;
                this.listerMatches.declined = response.data.declined;
                this.traderGuest = false;
                this.usub = true;
                // this.tokens = response.data.tts;

                VueEvent.$emit('loadedTraders', this.traders);
                // this.storeLocally(response.data);
            }).catch((error) => {
                // if (error.response.status === 418) {
                    // Subscription required
                // } else {
                    this.handleError(error);
                // }
            });
        },

        getTokens() {
            axios.get('/api/my/tokens').then(response => {
                this.tokens = response.data.tts;
                VueEvent.$emit('loadedTokens', this.tokens);
            }).catch((error) => {
                this.handleError(error);
            });
        },

        storeLocally(data) {
            localStorage.setItem('traders', JSON.stringify(data));
            let now = new Date();
            // localStorage.setItem('tradersLoaded', JSON.stringify({'u': this.user.id, 't': now.getTime()}));
            localStorage.setItem('tradersLoaded', JSON.stringify({'u': null, 'b': this.boardId ? this.boardId : null, 't': now.getTime()}));
        },

        diffLoaded (dt) {
            let now = new Date();
            let diff = (now.getTime() - dt) / 1000;
            diff /= 60;
            return Math.abs(Math.round(diff));
        },

        submitTrade() {
            if (this.processingSubmit) {
                return;
            }
            let traders = this.traders.filter(trader => trader.selected);
            // axios.post('/pin-trading/listings/' + this.pin.id + '/offers', {
            this.processingSubmit = true;
            axios.post('/pin-trading/offers', {
                tradeListing: this.pin.id,
                // listedPin: this.pin.pinventory_id,
                listedPin: this.pin.collection_id,
                offeredPins: traders.map(trader => trader.id)
            }).then(response => {
                // let index = this.listings.findIndex(x => x.id === this.listedPin.id);
                // this.listings[index].pendingOffer = traders;
                VueEvent.$emit('madeTradeOffer', this.pin.id, traders);

                this.pin.pendingOffer = traders;
                this.listedPin = false;
                this.listedPinTraded = false;
                this.traders.forEach((trader) => {
                    trader.selected = false;
                });

                this.tradeStep = 4;
                this.processingSubmit = false;
                Confetti({
                    particleCount: 100,
                    spread: 70,
                    origin: {y: 0.6},
                    zIndex: 10000
                });
            }).catch(error => {
                if (error.response.status === 406) {
                    // Traders are not available
                    this.tradersNA = true;
                } else if (error.response.status === 410) {
                    // Listed pin has already been traded
                    this.listingTraded = true;
                    this.pin.traded = true;
                } else {
                    this.handleError(error);
                }
            });
        },

        toggleTraderPin(traderId, toggle = null) {
            let index = this.traders.findIndex(x => x.id === traderId),
                pin = this.traders[index].pin_id,
                matches = this.traders.filter(x => x.pin_id === pin);

            matches.forEach(match => {
                match.selected = toggle !== null ? toggle : !match.selected;
            });
        },

        goStep(step) {
            this.tradeStep = step;
            this.tradersNA = false;
            // document.querySelector('.modal-header').scrollIntoView();
        },

        handleError(error) {
            if (error.response === undefined) {
                // throw new Error(error);
            } else {
                if (error.response.status === 401) {
                    window.location.href = '/login?intended='+window.location.pathname;
                } else if (error.response.status === 403) {
                    this.uban = true;
                } else if (error.response.status === 419) {
                    window.location.reload();
                } else if (error.response.status === 410) {
                    window.location.href = '/trade-arcade';
                }
            }
        }
    },
    mounted() {
        document.getElementById('trade-pin-detail').addEventListener('hidden.bs.modal', () => {
            this.tradeStep = 1;
            this.tradersNA = false;
            this.listingTraded = false;
            this.traders.forEach((trader) => {
                trader.selected = false;
            });
        });

        // if (this.boardId) {
        //     this.getTraders();
        // }

        // Cache traders in localStorage
        if (this.boardId !== false) {
            if (localStorage.tradersLoaded && localStorage.traders) {
                this.tradersLoaded = JSON.parse(localStorage.getItem('tradersLoaded'));
                if (this.diffLoaded(this.tradersLoaded.t) > 10 || this.tradersLoaded.b !== this.boardId) {
                    this.getTraders();
                } else {
                    let data = JSON.parse(localStorage.getItem('traders'));
                    this.traders = data.traders;
                    this.listerMatches.isos = data.isos;
                    this.listerMatches.grails = data.grails;
                    this.listerMatches.tags = data.tags;
                    this.listerMatches.owns = data.owns;
                    this.listerMatches.declined = data.declined;
                    this.traderGuest = false;
                    this.usub = true;

                    VueEvent.$emit('loadedTraders', this.traders);
                }
            } else {
                this.getTraders();
            }

            this.getTokens();

            // if (this.tradersLoaded && this.tradersLoaded.u !== this.user.id) {
            if (this.tradersLoaded && this.tradersLoaded.b !== this.boardId) {
                localStorage.removeItem('traders');
                localStorage.removeItem('tradersLoaded');
            }
        }
    },
    created() {
        VueEvent.$on('chosenTradePin', (id) => {
            if (this.listings) {
                this.pin = this.listings.find(p => p.id === id);
            } else {
                this.getListing(id).then(response => {
                    this.pin = response;
                    if (response.trade) {
                        this.traderGuest = false;
                        this.pin.traded = true;
                    } else {
                        this.getTraders();
                    }
                });
            }
        });

        // VueEvent.$on('toggleTraderPin', (traderId, toggle=null) => {
        //     let index = this.traders.findIndex(x => x.id === traderId),
        //         pin = this.traders[index].pin_id,
        //         matches = this.traders.filter(x => x.pin_id === pin);
        //
        //     matches.forEach(match => {
        //         match.selected = toggle !== null ? toggle : !match.selected;
        //     });
        // });
    }
}
</script>
